export default __webpack_public_path__ + "static/media/School+2-min.18165619.png";